export const CHANGE_PARAMETER_CONFIGURATION_REQUEST =
  "CHANGE_PARAMETER_CONFIGURATION_REQUEST";
export const CHANGE_PARAMETER_CONFIGURATION_SUCCESS =
  "CHANGE_PARAMETER_CONFIGURATION_SUCCESS";
export const CHANGE_PARAMETER_CONFIGURATION_FAILURE =
  "CHANGE_PARAMETER_CONFIGURATION_FAILURE";
export const RESET_APPLICATION_PARAMETER_STATE =
  "RESET_APPLICATION_PARAMETER_STATE";
